import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { CLINIC } from "@/constants/testIds";

/** Card de Ajustes: financiamiento (ej. Cherry) que la clínica ofrece a sus
 * pacientes. Fix E (2026-09-09): solo muestra e enlaza al formulario del
 * proveedor externo, sin integración por API. */
export default function FinancingSettingsCard({ clinic, onUpdated }) {
  const [enabled, setEnabled] = useState(clinic.financing_enabled ?? false);
  const [provider, setProvider] = useState(clinic.financing_provider || "");
  const [url, setUrl] = useState(clinic.financing_url || "");
  const [note, setNote] = useState(clinic.financing_note || "");
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/clinic", {
        financing_enabled: enabled,
        financing_provider: provider || null,
        financing_url: url || null,
        financing_note: note || null,
      });
      onUpdated(data);
      toast({ title: "Financiamiento actualizado" });
    } catch (err) {
      toast({ title: "Error al guardar", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-border rounded-xl p-6 sm:p-8 shadow-sm space-y-5" data-testid={CLINIC.financingCard}>
      <div>
        <h2 className="font-serif text-xl text-foreground">Financiamiento</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Mostrá que tu clínica ofrece financiamiento en cuotas (ej. Cherry) en la landing y en la confirmación de la reserva pública. Solo informativo: no se integra por API.
        </p>
      </div>

      <label className="flex items-center gap-3 cursor-pointer">
        <Switch checked={enabled} onCheckedChange={setEnabled} data-testid={CLINIC.financingToggle} />
        <span className="text-sm text-foreground">Ofrecemos financiamiento</span>
      </label>

      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Proveedor</Label>
        <Input value={provider} onChange={(e) => setProvider(e.target.value)} placeholder="Cherry" data-testid={CLINIC.financingProviderInput} />
      </div>
      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Enlace al formulario de solicitud</Label>
        <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://withcherry.com/..." data-testid={CLINIC.financingUrlInput} />
      </div>
      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Texto corto</Label>
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Financiá tu tratamiento en cuotas" data-testid={CLINIC.financingNoteInput} />
      </div>

      <Button onClick={handleSave} disabled={saving} className="bg-brand hover:bg-brand-hover text-white" data-testid={CLINIC.financingSaveButton}>
        {saving ? "Guardando..." : "Guardar cambios"}
      </Button>
    </div>
  );
}
